module.exports = __webpack_public_path__ + "img/logo.96f4dc90.svg";